import logger from 'shared/services/logger'
import Storage from './storage'

class DataLayerSearchHistoryService {
  STORAGE_KEY = 'dataLayerSearch'

  storage = new Storage('sessionStorage')
  isEnabled = false

  constructor() {
    this.isEnabled = this.storage.isAvailable()

    if (!this.isEnabled) {
      logger.info('DataLayerSearchHistoryService is not available')
    }
  }

  get = () => {
    if (this.isEnabled) {
      return this.storage.get(this.STORAGE_KEY) || {}
    }

    return {}
  }

  set = value => {
    if (!this.isEnabled) {
      return null
    }

    try {
      this.storage.set(this.STORAGE_KEY, value)

      return true
    } catch (error) {
      return false
    }
  }

  clear = () => {
    this.set({})
  }
}

export default new DataLayerSearchHistoryService()
